export type PantryStatus = 'aktibo' | 'mababa-stock' | 'walang-stock' | 'hindi-aktibo';
export type AvailabilityLevel = 'mataas' | 'katamtaman' | 'mababa' | 'wala';

export interface Pantry {
  id: string;
  pangalan: string;
  address: string;
  barangay: string;
  lungsod: string;
  lat: number;
  lng: number;
  status: PantryStatus;
  items: string[];
  oras: string;
  contact: string;
  nagtatag: string;
  hulingUpdate: string;
  larawan?: string;
  itemAvailability?: Record<string, AvailabilityLevel>;
  bankAccountDetails?: string;
  qrCodeUrl?: string;
  facebookUrl?: string;
  instagramUrl?: string;
  twitterUrl?: string;
  messengerUrl?: string;
  nearestLandmark?: string;
  contactPerson?: string;
  pantryPassword?: string;
  // New profile fields
  description?: string;
  photoUrl?: string;
  howItStarted?: string;
  scheduleType?: 'fixed' | 'varies';
  scheduleDetails?: string;
}

export interface Submission {
  id: string;
  pangalan: string;
  address: string;
  barangay: string;
  lungsod: string;
  lat: number;
  lng: number;
  items: string[];
  oras: string;
  contact: string;
  nagtatag: string;
  nagpadala: string;
  emailNagpadala: string;
  petsa: string;
  status: 'nakabinbin' | 'naaprubahan' | 'tinanggihan';
  nota?: string;
  bankAccountDetails?: string;
  qrCodeUrl?: string;
  facebookUrl?: string;
  instagramUrl?: string;
  twitterUrl?: string;
  messengerUrl?: string;
  nearestLandmark?: string;
  contactPerson?: string;
  // New profile fields
  description?: string;
  photoUrl?: string;
  howItStarted?: string;
  scheduleType?: 'fixed' | 'varies';
  scheduleDetails?: string;
}

export interface Report {
  id: string;
  pantryId: string;
  pantryPangalan: string;
  uri: 'walang-stock' | 'hindi-na-aktibo' | 'maling-impormasyon' | 'iba-pa';
  detalye: string;
  nagulat: string;
  petsa: string;
  status: 'nakabinbin' | 'naresolba' | 'tinanggihan';
}

export const PANTRY_DATA: Pantry[] = [
  {
    id: 'pantry-001',
    pangalan: 'Pantry ni Aling Nena',
    address: '42 Rizal Street, Barangay Pinyahan',
    barangay: 'Pinyahan',
    lungsod: 'Quezon City',
    lat: 14.6282,
    lng: 121.0614,
    status: 'aktibo',
    items: ['Bigas', 'Sardinas', 'Mie', 'Asin', 'Asukal', 'Mantika'],
    oras: 'Lunes–Sabado, 7:00 AM – 11:00 AM',
    contact: '0917-234-5678',
    nagtatag: 'Barangay Pinyahan Tanggapan',
    hulingUpdate: '2026-04-15T06:30:00',
  },
  {
    id: 'pantry-002',
    pangalan: 'Bayanihan Pantry — Tondo',
    address: '15 Moriones Street, Barangay 105',
    barangay: 'Barangay 105',
    lungsod: 'Maynila',
    lat: 14.6197,
    lng: 120.9673,
    status: 'aktibo',
    items: ['Bigas', 'Gulay', 'Itlog', 'Gatas', 'Tinapay'],
    oras: 'Araw-araw, 6:00 AM – 10:00 AM',
    contact: '0928-111-2222',
    nagtatag: 'Samahan ng mga Magulang — Tondo',
    hulingUpdate: '2026-04-14T18:00:00',
  },
  {
    id: 'pantry-003',
    pangalan: 'Pantry ng Pag-asa — Marikina',
    address: '8 Shoe Avenue, Barangay Concepcion Uno',
    barangay: 'Concepcion Uno',
    lungsod: 'Marikina',
    lat: 14.6507,
    lng: 121.1029,
    status: 'mababa-stock',
    items: ['Sardinas', 'Asin'],
    oras: 'Martes at Huwebes, 8:00 AM – 12:00 NN',
    contact: '0939-456-7890',
    nagtatag: 'Marikina Youth Volunteers',
    hulingUpdate: '2026-04-15T07:00:00',
  },
  {
    id: 'pantry-004',
    pangalan: 'Kusina ng Komunidad — Mandaluyong',
    address: '3 Boni Avenue, Barangay Hulo',
    barangay: 'Hulo',
    lungsod: 'Mandaluyong',
    lat: 14.5794,
    lng: 121.0359,
    status: 'aktibo',
    items: ['Bigas', 'Noodles', 'De Lata', 'Tinapay', 'Mantika', 'Sibuyas', 'Bawang'],
    oras: 'Lunes–Biyernes, 7:00 AM – 9:00 AM',
    contact: '0956-789-0123',
    nagtatag: 'Mandaluyong Bayanihan Circle',
    hulingUpdate: '2026-04-15T07:15:00',
  },
  {
    id: 'pantry-005',
    pangalan: 'Pantry Lagi Tayo — Pasig',
    address: '22 Ortigas Avenue Extension, Barangay Rosario',
    barangay: 'Rosario',
    lungsod: 'Pasig',
    lat: 14.5764,
    lng: 121.0851,
    status: 'walang-stock',
    items: [],
    oras: 'Sabado at Linggo, 8:00 AM – 11:00 AM',
    contact: '0912-345-6789',
    nagtatag: 'Pasig Bayanihan Network',
    hulingUpdate: '2026-04-13T10:00:00',
  },
  {
    id: 'pantry-006',
    pangalan: 'Bigayan Pantry — Caloocan',
    address: '100 A. Mabini Street, Barangay 15',
    barangay: 'Barangay 15',
    lungsod: 'Caloocan',
    lat: 14.6497,
    lng: 120.9672,
    status: 'aktibo',
    items: ['Bigas', 'Gulay', 'Itlog', 'Sardinas', 'Asukal', 'Kape'],
    oras: 'Araw-araw, 7:00 AM – 10:00 AM',
    contact: '0945-678-9012',
    nagtatag: 'Caloocan Civic Organization',
    hulingUpdate: '2026-04-15T06:45:00',
  },
  {
    id: 'pantry-007',
    pangalan: 'Pantry Damayan — Las Piñas',
    address: '55 Alabang-Zapote Road, Barangay Almanza Uno',
    barangay: 'Almanza Uno',
    lungsod: 'Las Piñas',
    lat: 14.4488,
    lng: 120.9928,
    status: 'aktibo',
    items: ['Bigas', 'Noodles', 'De Lata', 'Gatas', 'Tinapay'],
    oras: 'Miyerkules at Sabado, 7:30 AM – 10:30 AM',
    contact: '0967-890-1234',
    nagtatag: 'Las Piñas Volunteer Group',
    hulingUpdate: '2026-04-14T16:00:00',
  },
  {
    id: 'pantry-008',
    pangalan: 'Tulong Pantry — Paranaque',
    address: '18 Dr. A. Santos Avenue, Barangay BF Homes',
    barangay: 'BF Homes',
    lungsod: 'Parañaque',
    lat: 14.4793,
    lng: 121.0198,
    status: 'mababa-stock',
    items: ['Bigas', 'Asin'],
    oras: 'Lunes, Miyerkules, Biyernes, 8:00 AM – 11:00 AM',
    contact: '0978-901-2345',
    nagtatag: 'BF Homes HOA',
    hulingUpdate: '2026-04-15T05:30:00',
  },
  {
    id: 'pantry-009',
    pangalan: 'Pantry Malasakit — Valenzuela',
    address: '7 MacArthur Highway, Barangay Dalandanan',
    barangay: 'Dalandanan',
    lungsod: 'Valenzuela',
    lat: 14.7011,
    lng: 120.9830,
    status: 'aktibo',
    items: ['Bigas', 'Sardinas', 'Mie', 'Asin', 'Asukal', 'Mantika', 'Sibuyas'],
    oras: 'Lunes–Sabado, 6:30 AM – 9:30 AM',
    contact: '0989-012-3456',
    nagtatag: 'Valenzuela City Youth',
    hulingUpdate: '2026-04-15T07:30:00',
  },
  {
    id: 'pantry-010',
    pangalan: 'Pantry Pagmamahal — Makati',
    address: '30 Kalayaan Avenue, Barangay Palanan',
    barangay: 'Palanan',
    lungsod: 'Makati',
    lat: 14.5500,
    lng: 121.0150,
    status: 'hindi-aktibo',
    items: [],
    oras: 'Hindi na bukas',
    contact: '0900-000-0000',
    nagtatag: 'Makati CSR Group',
    hulingUpdate: '2026-04-01T00:00:00',
  },
];

export const SUBMISSION_DATA: Submission[] = [
  {
    id: 'sub-001',
    pangalan: 'Pantry Pagkakaisa — Muntinlupa',
    address: '12 Alabang Hills Road, Barangay Ayala Alabang',
    barangay: 'Ayala Alabang',
    lungsod: 'Muntinlupa',
    lat: 14.4200,
    lng: 121.0400,
    items: ['Bigas', 'Sardinas', 'Mie', 'Tinapay'],
    oras: 'Sabado at Linggo, 8:00 AM – 12:00 NN',
    contact: '0917-111-2222',
    nagtatag: 'Alabang Volunteers Inc.',
    nagpadala: 'Maria Santos',
    emailNagpadala: 'maria.santos@email.com',
    petsa: '2026-04-14T10:30:00',
    status: 'nakabinbin',
    nota: '',
  },
  {
    id: 'sub-002',
    pangalan: 'Bigayan Corner — Navotas',
    address: '5 Navotas Fish Port Area, Barangay Sipac-Almacen',
    barangay: 'Sipac-Almacen',
    lungsod: 'Navotas',
    lat: 14.6667,
    lng: 120.9417,
    items: ['Isda', 'Bigas', 'Asin', 'Gulay'],
    oras: 'Araw-araw, 5:00 AM – 8:00 AM',
    contact: '0928-333-4444',
    nagtatag: 'Navotas Fisherfolk Assoc.',
    nagpadala: 'Jose Reyes',
    emailNagpadala: 'jose.reyes@gmail.com',
    petsa: '2026-04-13T14:15:00',
    status: 'nakabinbin',
    nota: '',
  },
  {
    id: 'sub-003',
    pangalan: 'Pantry Tahanan — Malabon',
    address: '33 Longos Street, Barangay Longos',
    barangay: 'Longos',
    lungsod: 'Malabon',
    lat: 14.6680,
    lng: 120.9570,
    items: ['Bigas', 'Noodles', 'De Lata'],
    oras: 'Martes at Biyernes, 7:00 AM – 10:00 AM',
    contact: '0939-555-6666',
    nagtatag: 'Malabon Community Leaders',
    nagpadala: 'Ana Cruz',
    emailNagpadala: 'ana.cruz@yahoo.com',
    petsa: '2026-04-12T09:00:00',
    status: 'naaprubahan',
    nota: 'Napatunayan ng admin. Idinagdag sa mapa.',
  },
  {
    id: 'sub-004',
    pangalan: 'Pantry Magkakampi — San Juan',
    address: '9 Batis Street, Barangay Batis',
    barangay: 'Batis',
    lungsod: 'San Juan',
    lat: 14.6000,
    lng: 121.0300,
    items: ['Bigas', 'Sardinas', 'Itlog'],
    oras: 'Lunes–Biyernes, 8:00 AM – 11:00 AM',
    contact: '0956-777-8888',
    nagtatag: 'San Juan Youth Council',
    nagpadala: 'Pedro Dela Cruz',
    emailNagpadala: 'pedro.delacruz@outlook.com',
    petsa: '2026-04-11T11:45:00',
    status: 'tinanggihan',
    nota: 'Hindi mahanap ang address. Pakipalit ng tamang lokasyon.',
  },
];

export const REPORT_DATA: Report[] = [
  {
    id: 'rep-001',
    pantryId: 'pantry-005',
    pantryPangalan: 'Pantry Lagi Tayo — Pasig',
    uri: 'walang-stock',
    detalye: 'Pumunta ako kahapon ng umaga. Wala nang laman ang pantry. Matagal na siguro walang stock.',
    nagulat: 'Rosario Fernandez',
    petsa: '2026-04-14T09:20:00',
    status: 'nakabinbin',
  },
  {
    id: 'rep-002',
    pantryId: 'pantry-010',
    pantryPangalan: 'Pantry Pagmamahal — Makati',
    uri: 'hindi-na-aktibo',
    detalye: 'Ang pantry na ito ay hindi na bukas. Naalis na ang lahat ng gamit doon. Maaaring tanggalin sa mapa.',
    nagulat: 'Ernesto Villanueva',
    petsa: '2026-04-13T14:00:00',
    status: 'nakabinbin',
  },
  {
    id: 'rep-003',
    pantryId: 'pantry-003',
    pantryPangalan: 'Pantry ng Pag-asa — Marikina',
    uri: 'maling-impormasyon',
    detalye: 'Hindi tama ang oras. Nagsara na sila ng 9:00 AM, hindi 12:00 NN.',
    nagulat: 'Ligaya Bautista',
    petsa: '2026-04-15T06:00:00',
    status: 'nakabinbin',
  },
  {
    id: 'rep-004',
    pantryId: 'pantry-008',
    pantryPangalan: 'Tulong Pantry — Paranaque',
    uri: 'walang-stock',
    detalye: 'Konti na lang ang naiwan. Bigas at asin lang. Kailangan ng dagdag na donasyon.',
    nagulat: 'Crisanto Magpayo',
    petsa: '2026-04-15T07:45:00',
    status: 'naresolba',
  },
];

// ─── localStorage helpers ─────────────────────────────────────────────────────
const STORAGE_KEYS = {
  submissions: 'pantrymap_submissions',
  reports: 'pantrymap_reports',
  pantries: 'pantrymap_pantries',
};

function loadFromStorage<T>(key: string, fallback: T[]): T[] {
  if (typeof window === 'undefined') return fallback;
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw) as T[];
  } catch {
    return fallback;
  }
}

function saveToStorage<T>(key: string, data: T[]): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch {
    // storage quota exceeded — fail silently
  }
}

// Mutable reports store — shared between ReportModal and AdminDashboard
export const reportsStore: Report[] = loadFromStorage<Report>(STORAGE_KEYS.reports, [...REPORT_DATA]);

export function addReport(report: Report): void {
  reportsStore.unshift(report);
  saveToStorage(STORAGE_KEYS.reports, reportsStore);
}

export function updateReport(id: string, patch: Partial<Report>): void {
  const idx = reportsStore.findIndex((r) => r.id === id);
  if (idx !== -1) {
    reportsStore[idx] = { ...reportsStore[idx], ...patch };
    saveToStorage(STORAGE_KEYS.reports, reportsStore);
  }
}

// Mutable submissions store — shared between SubmitPantryForm and AdminDashboard
export const submissionsStore: Submission[] = loadFromStorage<Submission>(STORAGE_KEYS.submissions, [...SUBMISSION_DATA]);

export function addSubmission(submission: Submission): void {
  submissionsStore.unshift(submission);
  saveToStorage(STORAGE_KEYS.submissions, submissionsStore);
}

export function updateSubmission(id: string, patch: Partial<Submission>): void {
  const idx = submissionsStore.findIndex((s) => s.id === id);
  if (idx !== -1) {
    submissionsStore[idx] = { ...submissionsStore[idx], ...patch };
    saveToStorage(STORAGE_KEYS.submissions, submissionsStore);
  }
}

// ─── Mutable pantries store ───────────────────────────────────────────────────
// Shared between MapClientWrapper and AdminDashboard so changes in one
// are immediately visible in the other within the same browser session.

export let pantriesStore: Pantry[] = loadFromStorage<Pantry>(STORAGE_KEYS.pantries, [...PANTRY_DATA]);

type PantryListener = (pantries: Pantry[]) => void;
const pantryListeners: Set<PantryListener> = new Set();

export function subscribeToPantries(listener: PantryListener): () => void {
  pantryListeners.add(listener);
  return () => pantryListeners.delete(listener);
}

function notifyPantryListeners() {
  pantryListeners.forEach((fn) => fn([...pantriesStore]));
}

export function updatePantry(updated: Pantry): void {
  const idx = pantriesStore.findIndex((p) => p.id === updated.id);
  if (idx !== -1) {
    pantriesStore[idx] = updated;
    pantriesStore = [...pantriesStore];
    saveToStorage(STORAGE_KEYS.pantries, pantriesStore);
    notifyPantryListeners();
  }
}

export function addPantry(pantry: Pantry): void {
  pantriesStore = [pantry, ...pantriesStore];
  saveToStorage(STORAGE_KEYS.pantries, pantriesStore);
  notifyPantryListeners();
}

export function removePantry(id: string): void {
  pantriesStore = pantriesStore.filter((p) => p.id !== id);
  saveToStorage(STORAGE_KEYS.pantries, pantriesStore);
  notifyPantryListeners();
}

export function getPantries(): Pantry[] {
  return [...pantriesStore];
}

export const STATUS_LABELS: Record<string, string> = {
  'aktibo': 'Aktibo',
  'mababa-stock': 'Konti na lang',
  'walang-stock': 'Ubos na',
  'hindi-aktibo': 'Hindi na Bukas',
  'nakabinbin': 'Nakabinbin',
  'naaprubahan': 'Naaprubahan',
  'tinanggihan': 'Tinanggihan',
  'naresolba': 'Naresolba',
  'walang-stock-report': 'Ubos na',
  'hindi-na-aktibo': 'Hindi na Aktibo',
  'maling-impormasyon': 'Maling Impormasyon',
  'iba-pa': 'Iba pa',
};

export const LUNGSOD_LIST = [
  // Metro Manila (NCR)
  'Caloocan', 'Las Piñas', 'Makati', 'Malabon', 'Mandaluyong',
  'Marikina', 'Maynila', 'Muntinlupa', 'Navotas', 'Parañaque',
  'Pasay', 'Pasig', 'Pateros', 'Quezon City', 'San Juan',
  'Taguig', 'Valenzuela',
  // Region I – Ilocos Region
  'Laoag', 'Batac', 'Vigan', 'Candon', 'San Fernando (La Union)',
  'Dagupan', 'San Carlos (Pangasinan)', 'Urdaneta', 'Alaminos',
  // Region II – Cagayan Valley
  'Tuguegarao', 'Cauayan', 'Ilagan', 'Santiago',
  // Region III – Central Luzon
  'Angeles', 'Mabalacat', 'San Fernando (Pampanga)', 'Olongapo',
  'Balanga', 'Meycauayan', 'Malolos', 'San Jose del Monte',
  'Cabanatuan', 'Gapan', 'Muñoz', 'Palayan', 'Science City of Muñoz',
  'Tarlac City',
  // Region IV-A – CALABARZON
  'Antipolo', 'Biñan', 'Cabuyao', 'Calamba', 'San Pablo',
  'San Pedro', 'Santa Rosa', 'Batangas City', 'Lipa', 'Tanauan',
  'Cavite City', 'Bacoor', 'Dasmariñas', 'General Trias', 'Imus',
  'Tagaytay', 'Trece Martires', 'Lucena', 'Tayabas',
  // Region IV-B – MIMAROPA
  'Puerto Princesa', 'Calapan', 'Romblon', 'Mamburao', 'Boac',
  // Region V – Bicol Region
  'Legazpi', 'Ligao', 'Tabaco', 'Naga (Camarines Sur)', 'Iriga',
  'Masbate City', 'Sorsogon City',
  // Region VI – Western Visayas
  'Iloilo City', 'Passi', 'Bacolod', 'Bago', 'Cadiz', 'Escalante',
  'Himamaylan', 'Kabankalan', 'La Carlota', 'Sagay', 'San Carlos (Negros Occidental)',
  'Silay', 'Sipalay', 'Talisay (Negros Occidental)', 'Victorias',
  'Roxas City', 'Kalibo',
  // Region VII – Central Visayas
  'Cebu City', 'Carcar', 'Danao', 'Lapu-Lapu', 'Mandaue',
  'Naga (Cebu)', 'Talisay (Cebu)', 'Toledo', 'Bogo',
  'Tagbilaran', 'Dumaguete', 'Bais', 'Bayawan', 'Canlaon',
  'Guihulngan', 'Tanjay',
  // Region VIII – Eastern Visayas
  'Tacloban', 'Ormoc', 'Baybay', 'Maasin', 'Borongan', 'Catbalogan', 'Calbayog',
  // Region IX – Zamboanga Peninsula
  'Zamboanga City', 'Dapitan', 'Dipolog', 'Isabela City', 'Pagadian',
  // Region X – Northern Mindanao
  'Cagayan de Oro', 'El Salvador', 'Gingoog', 'Iligan', 'Malaybalay',
  'Valencia', 'Oroquieta', 'Ozamiz', 'Tangub',
  // Region XI – Davao Region
  'Davao City', 'Digos', 'Mati', 'Panabo', 'Samal', 'Tagum',
  // Region XII – SOCCSKSARGEN
  'Cotabato City', 'Kidapawan', 'Koronadal', 'Tacurong', 'General Santos',
  // Region XIII – Caraga
  'Butuan', 'Bayugan', 'Bislig', 'Cabadbaran', 'Surigao City', 'Tandag',
  // BARMM
  'Marawi', 'Lamitan',
  // CAR – Cordillera Administrative Region
  'Baguio', 'Tabuk', 'Bangued', 'Lagawe', 'Bontoc', 'La Trinidad', 'Potia',
];

export const REGION_CITY_MAP: Record<string, string[]> = {
  'NCR – Metro Manila': [
    'Caloocan', 'Las Piñas', 'Makati', 'Malabon', 'Mandaluyong',
    'Marikina', 'Maynila', 'Muntinlupa', 'Navotas', 'Parañaque',
    'Pasay', 'Pasig', 'Pateros', 'Quezon City', 'San Juan',
    'Taguig', 'Valenzuela',
  ],
  'Region I – Ilocos Region': [
    'Laoag', 'Batac', 'Vigan', 'Candon', 'San Fernando (La Union)',
    'Dagupan', 'San Carlos (Pangasinan)', 'Urdaneta', 'Alaminos',
  ],
  'Region II – Cagayan Valley': [
    'Tuguegarao', 'Cauayan', 'Ilagan', 'Santiago',
  ],
  'Region III – Central Luzon': [
    'Angeles', 'Mabalacat', 'San Fernando (Pampanga)', 'Olongapo',
    'Balanga', 'Meycauayan', 'Malolos', 'San Jose del Monte',
    'Cabanatuan', 'Gapan', 'Muñoz', 'Palayan', 'Science City of Muñoz',
    'Tarlac City',
  ],
  'Region IV-A – CALABARZON': [
    'Antipolo', 'Biñan', 'Cabuyao', 'Calamba', 'San Pablo',
    'San Pedro', 'Santa Rosa', 'Batangas City', 'Lipa', 'Tanauan',
    'Cavite City', 'Bacoor', 'Dasmariñas', 'General Trias', 'Imus',
    'Tagaytay', 'Trece Martires', 'Lucena', 'Tayabas',
  ],
  'Region IV-B – MIMAROPA': [
    'Puerto Princesa', 'Calapan', 'Romblon', 'Mamburao', 'Boac',
  ],
  'Region V – Bicol Region': [
    'Legazpi', 'Ligao', 'Tabaco', 'Naga (Camarines Sur)', 'Iriga',
    'Masbate City', 'Sorsogon City',
  ],
  'Region VI – Western Visayas': [
    'Iloilo City', 'Passi', 'Bacolod', 'Bago', 'Cadiz', 'Escalante',
    'Himamaylan', 'Kabankalan', 'La Carlota', 'Sagay', 'San Carlos (Negros Occidental)',
    'Silay', 'Sipalay', 'Talisay (Negros Occidental)', 'Victorias',
    'Roxas City', 'Kalibo',
  ],
  'Region VII – Central Visayas': [
    'Cebu City', 'Carcar', 'Danao', 'Lapu-Lapu', 'Mandaue',
    'Naga (Cebu)', 'Talisay (Cebu)', 'Toledo', 'Bogo',
    'Tagbilaran', 'Dumaguete', 'Bais', 'Bayawan', 'Canlaon',
    'Guihulngan', 'Tanjay',
  ],
  'Region VIII – Eastern Visayas': [
    'Tacloban', 'Ormoc', 'Baybay', 'Maasin', 'Borongan', 'Catbalogan', 'Calbayog',
  ],
  'Region IX – Zamboanga Peninsula': [
    'Zamboanga City', 'Dapitan', 'Dipolog', 'Isabela City', 'Pagadian',
  ],
  'Region X – Northern Mindanao': [
    'Cagayan de Oro', 'El Salvador', 'Gingoog', 'Iligan', 'Malaybalay',
    'Valencia', 'Oroquieta', 'Ozamiz', 'Tangub',
  ],
  'Region XI – Davao Region': [
    'Davao City', 'Digos', 'Mati', 'Panabo', 'Samal', 'Tagum',
  ],
  'Region XII – SOCCSKSARGEN': [
    'Cotabato City', 'Kidapawan', 'Koronadal', 'Tacurong', 'General Santos',
  ],
  'Region XIII – Caraga': [
    'Butuan', 'Bayugan', 'Bislig', 'Cabadbaran', 'Surigao City', 'Tandag',
  ],
  'BARMM': [
    'Marawi', 'Lamitan',
  ],
  'CAR – Cordillera Administrative Region': [
    'Baguio', 'Tabuk', 'Bangued', 'Lagawe', 'Bontoc', 'La Trinidad', 'Potia',
  ],
};

export const REGION_LIST = Object.keys(REGION_CITY_MAP);

export const PAGKAIN_LIST = [
  'Bigas', 'Sardinas', 'Mie/Noodles', 'Asin', 'Asukal', 'Mantika',
  'Sibuyas', 'Bawang', 'Gulay', 'Itlog', 'Gatas', 'Tinapay',
  'De Lata', 'Kape', 'Isda', 'Karne', 'Toyo', 'Suka',
  'Paminta', 'Patis',
];

export interface Donation {
  id: string;
  pantryId: string;
  pantryPangalan: string;
  pangalanDonor: string;
  contactDonor: string;
  mgaDonasyon: string[];
  ibaPaDonasyon: string;
  mensahe: string;
  petsa: string;
  status: 'nakabinbin' | 'natanggap' | 'tinanggihan';
}

export let DONATION_DATA: Donation[] = [];

export interface DonationHub {
  id: string;
  name: string;
  photoUrl?: string;
  location?: string;
  contact?: string;
  email?: string;
  representativeName?: string;
  qrCodeUrl?: string;
  description?: string;
  createdAt?: string;
  hubPassword?: string;
}

export interface PantryPost {
  id: string;
  pantryId: string;
  content: string;
  photoUrl?: string;
  photoUrls?: string[];
  createdAt: string;
}

export interface HubDonation {
  id: string;
  hubId: string;
  donorName: string;
  donorEmail?: string;
  donorContact: string;
  items?: string;
  message?: string;
  paymentMethod?: string;
  paymentScreenshotUrl?: string;
  status: 'nakabinbin' | 'natanggap' | 'tinanggihan';
  createdAt: string;
}